<template>
  <div>
    <!--    <b-alert show variant="danger">-->
    <!--      <i class="mdi mdi-alert-outline me-2"></i>-->
    <!--      Cari listesinden bir cari seçtikten sonra ürün arama sayfasından cari ile-->
    <!--      alakalı ürün ekleyebilirsiniz-->
    <!--    </b-alert>-->
    <p class="text-muted">
      Toplam {{ currentListMetaData.totalCount }} sonuç bulundu
    </p>
    <b-table
        :items="currentList"
        :fields="currentListHeaders.filter(item => item.visible)"
        hover
        responsive
        sort-icon-left
        :per-page="perPage"
        :busy="currentListLoading"
        @sort-changed="sortChanged"
        show-empty
        head-row-variant="info"
        table-variant="white"
    >
      <template #empty="scope">
        <h6 class="text-center my-5">
          {{ scope.loading ? "Lütfen Bekleyin" : noCurrentMessage }}
        </h6>
      </template>
      <template #cell(debit)="data">
        <span>{{ numberConverter(data.item.debit) }}</span>
      </template>
      <template #cell(overDueAmount)="data">
        <span>{{ numberConverter(data.item.overDueAmount) }}</span>
      </template>
      <template #cell(credit)="data">
        <span>{{ numberConverter(data.item.credit) }}</span>
      </template>
      <template #cell(balance)="data">
        <span>{{ numberConverter(data.item.balance) }}</span>
      </template>
      <template #cell(currencyBalance)="data">
        <span>{{ numberConverter(data.item.currencyBalance) }}</span>
      </template>
      <template #cell(selection)="data">
        <div style="padding-top: 0; justify-content: center; align-items: center; display: flex;">
          <v-checkbox
              dense
              :on-icon="'mdi-checkbox-marked'"
              :off-icon="'mdi-checkbox-blank-outline'"
              v-model="current"
              :true-value="data.item"
              :false-value="false"
              color="warning"
              hide-details
              style="padding-top: 0; justify-content: center; align-items: center; display: flex; margin-left: 3px; margin-right: 0;"
          >
          </v-checkbox>
        </div>
      </template>
      <template #cell(stockCurrentBills)="data">
        <div>
          <v-menu
              :v-model="showActionsMenu"
              bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  class="mx-1"
                  small
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  @click="showActionsMenu = data.item.code"
              >
                İşlemler
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                  @click="openCurrentStockActionsDialog(data.item)"
              >
                <v-list-item-icon>
                  <v-icon color="indigo darken-2">mdi-transfer</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Stok Hareketleri</v-list-item-title>
              </v-list-item>

              <v-list-item
                  @click="openCurrentActionsDialog(data.item)"
              >
                <v-list-item-icon>
                  <v-icon color="secondary darken-2">mdi-briefcase-arrow-left-right-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Cari Hareketleri</v-list-item-title>
              </v-list-item>

              <v-list-item
                  @click="openCurrentUnclosedInvoicesDialog(data.item)"
              >
                <v-list-item-icon>
                  <v-icon color="amber darken-2">mdi-file-document-alert-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Kapatılmamış Faturalar</v-list-item-title>
              </v-list-item>

              <v-list-item
                  @click="openCurrentVisitPage(data.item)"
              >
                <v-list-item-icon>
                  <v-icon color="amber darken-2">mdi-wallet-travel</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Ziyaretler</v-list-item-title>
              </v-list-item>

            </v-list>
          </v-menu>
        </div>
      </template>
      <template #table-busy>
        <div class="text-center">
          <b-spinner
              variant="primary"
              size="lg"
              label="Text Centered"
          ></b-spinner>
        </div>
      </template>
    </b-table>
    <CurrentStockActionsDialog
        :showDialog="showCurrentStockActionsDialog"
        :currentProp="currentStockActionsProp"
        @dialogChange="data => (showCurrentStockActionsDialog = data)"
    ></CurrentStockActionsDialog>
    <CurrentActionsDialog
        :showDialog="showCurrentActionsDialog"
        :currentProp="currentActionsProp"
        @dialogChange="data => (showCurrentActionsDialog = data)"
    ></CurrentActionsDialog>
    <CurrentUnclosedInvoicesDialog
        :showDialog="showCurrentUnclosedInvoicesDialog"
        :currentProp="currentUnclosedInvoicesProp"
        @dialogChange="data => (showCurrentUnclosedInvoicesDialog = data)"
    ></CurrentUnclosedInvoicesDialog>
  </div>
</template>

<script>
import {mapState, mapMutations, mapGetters, mapActions} from "vuex";

import CurrentStockActionsDialog from "@/components/current/dialogs/CurrentStockActionsDialog";
import CurrentActionsDialog from "@/components/current/dialogs/CurrentActionsDialog";
import CurrentUnclosedInvoicesDialog from "@/components/current/dialogs/CurrentUnclosedInvoicesDialog";
import {numberConverter} from "../../../../helpers";
import router from "@/router";
import {swalToast} from "@/helpers/swalToast";

export default {
  props: {
    perPage: {
      type: Number
    },
    currentPage: {
      type: Number
    }
  },
  components: {
    CurrentStockActionsDialog,
    CurrentActionsDialog,
    CurrentUnclosedInvoicesDialog
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("cart", ["current"]),
    ...mapState("current", [
      "currentList",
      "currentListHeaders",
      "currentListLoading",
      "currentListMetaData",
      "noCurrentMessage",
    ]),
    ...mapGetters("cart", ["getCurrent"]),
    current: {
      get() {
        return this.getCurrent;
      },
      set(value) {
        if (value) {
          swalToast.fire({
            title: "",
            text: "Cari : " + value.name + " seçildi",
            icon: "success",
            iconColor: 'green',
          });
          this.setCurrent(value);
          this.getCartList();
        } else {
          swalToast.fire({
            title: "",
            text: "Cari seçimi iptal edildi",
            icon: "error",
            iconColor: 'red',
          });
        this.setCurrent(value);
        this.getCartList();
        value = null;
        }
      },
    },
  },
  data() {
    return {
      showActionsMenu: false,
      selectRow: false,
      showCurrentStockActionsDialog: false,
      showCurrentActionsDialog: false,
      showCurrentUnclosedInvoicesDialog: false,
      currentStockActionsProp: null,
      currentActionsProp: null,
      currentUnclosedInvoicesProp: null,
      tableColumnSelectDialog: false,
    };
  },
  methods: {
    numberConverter,
    ...mapMutations("cart", ["setCurrent"]),
    ...mapMutations("current", ["setCurrentListHeaders"]),
    ...mapActions("cart", ["fetchSingleCartList"]),
    ...mapActions("visit",["setSelectedCurrentName","setSelectedCurrentCode"]),
    async getCartList() {
      await this.fetchSingleCartList({
        params: {},
        body: {
          UserId: this.user.UserId,
          CurrentCode: this.current.code
        }
      });
    },
    sortChanged(value) {
      value;
    },
    closeMenu() {
      this.showActionsMenu = false;
    },
    openCurrentStockActionsDialog(data) {
      this.currentStockActionsProp = data;
      this.showCurrentStockActionsDialog = true;
      this.closeMenu()
    },
    openCurrentActionsDialog(data) {
      this.currentActionsProp = data;
      this.showCurrentActionsDialog = true;
      this.closeMenu()
    },
    openCurrentUnclosedInvoicesDialog(data) {
      this.currentUnclosedInvoicesProp = data;
      this.showCurrentUnclosedInvoicesDialog = true;
      this.closeMenu()
    },
    openCurrentVisitPage(data) {
      this.setSelectedCurrentName(data.name);
      this.setSelectedCurrentCode(data.code);
      router.push(`/current-visit/${data.code}`)
      this.closeMenu();
    }
  },
  watch: {}
};
</script>

<style scoped>
</style>